export const getUtilityLabelByProduct = (productType, language) => {
  let utilityLabel1 = "";
    if (productType === "bilt") {
      utilityLabel1 = require("../components/resources/resources.casa");
    } else if (productType === "choice") {
      utilityLabel1 = require("../components/resources/resources.liberty");
    }  else if(productType === "rubicon") {
      utilityLabel1 = require("../components/resources/resources.rubicon");
    } else if (language === "es") {
      utilityLabel1 = require("../components/resources/resources.es");
    } else {
      utilityLabel1 = require("../components/resources/resources.en");
    }
    return utilityLabel1;
};

export const getUtilityLabelForFooter = (partner, language) => {
 let utilityLabel1 ="";
      if (partner === "bilt" || partner === "choice") {
        utilityLabel1 = require("../components/resources/resources.casa");
      }else if (partner === "rubicon") {
           utilityLabel1 = require("../components/resources/resources.rubicon");
      }else if (language === "es") {
        utilityLabel1 = require("../components/resources/resources.es");
      }else{
           utilityLabel1 = require("../components/resources/resources.en");
      }
      return utilityLabel1;
};
